
import common from './de/common';
import home from './de/home';
import airports from './de/airports';
import profiles from './de/profiles';
import settings from './de/settings';
import reviews from './de/reviews';
import inventory from './de/inventory';
import auth from './de/auth';
import navigation from './de/navigation';

// Merge all translation categories into one object
const translations = {
  ...common,
  ...home,
  ...airports,
  ...profiles,
  ...settings,
  ...reviews,
  ...inventory,
  ...auth,
  ...navigation,
};

export default translations;
